<mp-search-field
  class="raised"
  placeholder="Nach Export/Benutzer suchen"
  [searchTerm]="currentFilter().searchTerm"
  (searched)="onSearchbarSubmitted($event)"
  (cleared)="onSearchbarClear()"
/>

<mp-toggle-filter
  filterName="Nur mit Warnungen"
  icon="report_problem"
  [checked]="currentFilter().warningsOnly"
  (checkedChange)="handleWarningStateFilterChange($event)"
/>

<div>
  <mp-single-selection-group
    #statusFilter
    filterName="Status"
    icon="verified"
    [options]="stateTypeFilterOptions"
    [selectedValue]="currentFilter().stateType"
    (selectedValueChange)="handleStatusFilterChange($event)"
    (optionSelect)="trackFilterValueSelect($event.label, statusFilter.filterName())"
    (isExpandedChange)="trackFilterExpansionChange($event, statusFilter.filterName())"
  />

  <mp-multi-selection-group
    #exportTypeFilter
    filterName="Typ"
    icon="label"
    [options]="exportTypeFilterOptions()"
    [selectedValues]="currentFilter().exportTypes"
    (selectedValuesChange)="handleExportTypesFilterChange($event)"
    (optionSelect)="trackFilterValueSelect($event.label, exportTypeFilter.filterName())"
    (isExpandedChange)="trackFilterExpansionChange($event, exportTypeFilter.filterName())"
  />
</div>
